(() => {
  const readCartRecommendedProducts = () => {

    const isCartRecommendedProdcutsEnabled = window._growthbook?.getFeatureValue(
      "cart-recommended-products",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (isCartRecommendedProdcutsEnabled && isHoldoutGroupEnable === "OFF") {
      document.body.setAttribute("data-recommended-products", "true");
    }
  };

  const readPdmStickyAtcFF = () => {
    const pdmStickyRibbonEnabled = window._growthbook?.getFeatureValue(
      "pdm-sticky-atc-feature",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (pdmStickyRibbonEnabled) {
      document.body.setAttribute("data-sticky-atc-anchor", "true");
    }
  };

  const readPlpInfoCards = () => {
    const pdmInfoCardsEnabled = window._growthbook?.getFeatureValue(
      "pdm-plp-info-card",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (pdmInfoCardsEnabled && isHoldoutGroupEnable === "OFF") {
      document.body.setAttribute("data-plp-info-card", "true");
    }

  };

  const readExpressPay = () => {

    const isExpressPayEnabled = window._growthbook?.getFeatureValue(
      "express-pay-in-side-cart",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (isExpressPayEnabled && isHoldoutGroupEnable === "OFF") {
      document.body.setAttribute("data-express-checkout", "true");
      (function () {
        const observer = new MutationObserver((mutations, obs) => {
          const savedby = document.querySelector('savedby-checkout-plus');
          const hidden = document.querySelector('#hidden-express-buttons');

          const shopPayButton = document.querySelector('[slot="button-ShopPay"]');
          const shopPaypal = document.querySelector('[slot="button-PayPal"]');
          const shopGooglePay = document.querySelector('[slot="button-GooglePay"]');

          if (shopPayButton && shopPaypal && shopGooglePay) {
            shopPayButton.addEventListener('click', () => {
              gtag("event", "Shop_Side_Cart_Click")
            });

            shopPaypal.addEventListener('click', () => {
              gtag("event", "Shop_Side_Cart_Click")
            });

            shopGooglePay.addEventListener('click', () => {
              gtag("event", "Shop_Side_Cart_Click")
            });
          };

          if (!savedby?.shadowRoot || !hidden) return;

          const root = savedby.shadowRoot;
          const container = root.querySelector('.sb__checkout-container');
          const buttonWrapper = root.querySelector('.sb__button-wrapper');
          const nonCoveredLink = root.querySelector('.sb__non-covered-link');

          if (!container || !buttonWrapper || !nonCoveredLink) return;

          // Prevent duplicates
          if (root.querySelector('.my-express-checkout-buttons')) {
            obs.disconnect();
            return;
          }

          // Clone the express checkout buttons
          const clone = hidden.cloneNode(true);
          clone.id = '';
          clone.className = 'my-express-checkout-buttons';
          clone.style.display = 'flex';

          // Insert between elements
          const nonCoveredParent = nonCoveredLink.parentElement;
          container.insertBefore(clone, nonCoveredParent);

          // Injest styles to shadow DOM
          const style = document.createElement('style');
          style.textContent = `
                .my-express-checkout-buttons {
                  width: auto;
                  flex-direction: column;
                  padding: 0px 0px 16px 0px;
                }
                .express-checkout-title {
                    display: block;
                    text-align: center;
                    margin-bottom: 16px;
                    font-family: "Nunito Sans", sans-serif;
                    letter-spacing: normal;
                    color: rgba(51, 48, 43, 0.56);
                    font-size: 14px;
                }
                #shopify-buyer-consent {
                  display: none;
                }
                @media screen and (min-width: 353px) {
                  .my-express-checkout-buttons {
                    width: 98vw;
                  }
                }
                @media screen and (min-width: 580px) {
                  .my-express-checkout-buttons {
                    width: 80.5%;
                    padding: 0px 8px 16px 8px;
                  }
                }
              `;
          root.appendChild(style);

          obs.disconnect();
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      })();
    }
  };

  const readVideoSectionVisibility = () => {

    const isVideoSectionVisibility = window._growthbook?.getFeatureValue(
      "pdm-video-section-visibility",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (isVideoSectionVisibility && isHoldoutGroupEnable === "OFF") {
        document.body.setAttribute("data-video-section-visibility", "true");
    }
  };

  const readHowManyAreYouServing = () => {
    const pdmHowManyAreYouServingEnabled = window._growthbook?.getFeatureValue(
      "pdm-how-many-are-you-serving",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (pdmHowManyAreYouServingEnabled && isHoldoutGroupEnable === "OFF") {
        document.body.setAttribute("data-how-many-are-you-serving", "true");
    }
  };

    const readRotatingValueProps = () => {
    const pdmRotatingValuePropsEnable = window._growthbook?.getFeatureValue(
      "pdm-hp-rotating-value-props",
      false
    );

    const isHoldoutGroupEnable = window._growthbook.getFeatureValue(
      "holdout-pdm-the-meatery", // fijarse en el valor del feature flag del holdout group
      "OFF",
    );

    if (pdmRotatingValuePropsEnable && isHoldoutGroupEnable === "OFF") {
        document.body.setAttribute("data-rotating-value-props", "true");
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      readPdmStickyAtcFF();
      readCartRecommendedProducts();
      readExpressPay();
      readPlpInfoCards();
      readVideoSectionVisibility();
      readHowManyAreYouServing();
      readRotatingValueProps();
    };

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();